import { uploadImage } from '../utils/upload';
import axios from 'axios';
import { resetMyOrganizations } from '../utils/useMyOrganizations';
import { Prod, Prod01 } from '../constants/ActionType';

import { 
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    LOGOUT_SUCCESS,
    LOGOUT_FAIL,
    STAFF_LOGOUT_SUCCESS,
    STAFF_LOGOUT_FAIL,
    ADMIN_PASSWORD_UPDATE_REQUEST,
    ADMIN_PASSWORD_UPDATE_FAIL,
    HR_LOGOUT_SUCCESS,
    HR_LOGOUT_FAIL,
    FETCH_PROFILE_SUCCESS,
    FETCH_PROFILE_FAIL,
    CLEAR_ERRORS
} from '../constants/authConstants';

import { 
    SHOW_ALERT_MESSAGE,
    HIDE_ALERT_MESSAGE,
    FETCH_ERROR
} from '../constants/Common';

const LEGACY_USER_KEYS = ['admin', 'doctor', 'hr'];

// Login: email + password only; the backend resolves the account (admin > doctor > hr) and returns its role.
export const login = (values) => async(dispatch) => {
    const { email, password } = values;
    try {
       dispatch({
           type: LOGIN_REQUEST
       })

       // A token left on axios by an earlier session must not ride along on the login call.
       delete axios.defaults.headers.common["authorization"];
       const res = await axios.post(`${Prod01}/auth/login`, {
           email,
           password
       });

       const { user, kind, tokens } = res.data;
       axios.defaults.headers.common["authorization"] = "Bearer " + tokens.access.token;
       LEGACY_USER_KEYS.forEach((key) => localStorage.removeItem(key));
       localStorage.setItem("token", JSON.stringify(tokens.access.token));
       localStorage.setItem(LEGACY_USER_KEYS.includes(kind) ? kind : "admin", JSON.stringify(user));

       dispatch({
           type: LOGIN_SUCCESS,
           payload: user
       })

    } catch (error) {
        dispatch({
            type: FETCH_ERROR,
            payload: error?.response?.data?.message || error.message
          })

          dispatch({
              type: LOGIN_FAIL
          })
    }
}

// HR Logout 
export const hrLogout = () => async(dispatch) => {
    try {
       localStorage.removeItem("token"); localStorage.removeItem("admin"); localStorage.removeItem("doctor"); localStorage.removeItem("hr"); localStorage.removeItem("expireTime"); resetMyOrganizations();
       
       await axios.post(`${Prod01}/hr/signout`);

       dispatch({
           type: HR_LOGOUT_SUCCESS
       })
       
    } catch (error) {
        dispatch({
            type: HR_LOGOUT_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

// Update Password -> ADMIN 
export const updatePassword = (id, name, email) => async(dispatch) => {
    try {
       dispatch({
           type: ADMIN_PASSWORD_UPDATE_REQUEST
       })     

        await axios.put(`${Prod}/admin/edit/${id}`, {
           name: name,
           email: email
       });

       dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "Account Information updated"
        });
        
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })

        dispatch(getAdminProfile(id));

    } catch (error) {
        dispatch({
            type: ADMIN_PASSWORD_UPDATE_FAIL,
            payload: "unable to update"
        })
    }
}

export const AddProfileImgAdmin = (image, id) => async(dispatch) => {
    try {
        const { filename } = await uploadImage(image);

    await axios.put(`${Prod01}/admin/edit/profileImg/${id}`, {
        profileImg: filename
    });

    dispatch({
        type: SHOW_ALERT_MESSAGE,
        payload: "Profile Image Added"
    });
        
    dispatch({
        type: HIDE_ALERT_MESSAGE
    }) 
    
    dispatch(getAdminProfile(id));

    } catch (error) {
        dispatch({
            type: ADMIN_PASSWORD_UPDATE_FAIL,
            payload: "unable to add image"
        })
    }
}


export const changeAdminPassword = (id, oldPassword, newPassword) => async(dispatch) => {
    try {
        
    await axios.put(`${Prod01}/admin/edit/${id}`, {
        oldPassword: oldPassword,
        password: newPassword
    });

    dispatch({
        type: SHOW_ALERT_MESSAGE,
        payload: "Password Updated"
    });
        
    dispatch({
        type: HIDE_ALERT_MESSAGE
    }) 
    
    dispatch(getAdminProfile(id));

    } catch (error) {
        dispatch({
            type: ADMIN_PASSWORD_UPDATE_FAIL,
            payload: error.message
        })
    }
}



export const getAdminProfile = (Id) => async(dispatch) => {
    try {
       const res = await axios.post(`${Prod01}/admin/profile/${Id}`);
        
        dispatch({
            type: FETCH_PROFILE_SUCCESS,
            payload: res.data 
        })


    } catch (error) {
        dispatch({
            type: FETCH_PROFILE_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

// Logout 
export const logout = () => async(dispatch) => {
    try {
       delete axios.defaults.headers.common["authorization"];
       localStorage.removeItem("token"); localStorage.removeItem("admin"); localStorage.removeItem("doctor"); localStorage.removeItem("hr"); localStorage.removeItem("expireTime"); resetMyOrganizations();
       dispatch({
           type: LOGOUT_SUCCESS
       })
       
    } catch (error) {
        dispatch({
            type: LOGOUT_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}


// Logout 
export const staffLogout = () => async(dispatch) => {
    try {
       localStorage.removeItem("token"); localStorage.removeItem("admin"); localStorage.removeItem("doctor"); localStorage.removeItem("hr"); localStorage.removeItem("expireTime"); resetMyOrganizations();
        await axios.post(`${Prod01}/doctor/signout`);
        dispatch({
            type: STAFF_LOGOUT_SUCCESS
        })


       
    } catch (error) {
        dispatch({
            type: STAFF_LOGOUT_FAIL,
            payload: error?.response?.data?.message || error.message
        })
    }
}

export const forgotpassword = (values) => async(dispatch) => {
    const { email } = values;  
    try {
       const res  = await axios.post(`${Prod01}/auth/forgot-password`, {
           email
       });
      
       if(res){
        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "Email Sent"
          });
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })
       }
       
       
    } catch (error) {
       dispatch({
        type: FETCH_ERROR,
        payload: 'Email cannot be sent'
      })
      dispatch({
        type: HIDE_ALERT_MESSAGE
      })
    }
}

export const resetpassword = (values, queryToken) => async(dispatch) => {
    const { password } = values;  
    try {
       const res = await axios.post(`${Prod01}/auth/reset-password?token=${queryToken}`, {
           password: password
       });
      
       if(res){
        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "Password has been reset"
          });
        dispatch({
            type: HIDE_ALERT_MESSAGE
        })
       }
       
       
    } catch (error) {
       dispatch({
        type: FETCH_ERROR,
        payload: 'Unable to update password'
      })
      dispatch({
        type: HIDE_ALERT_MESSAGE
      })
    }
}

export const adminSignup = (values) => async(dispatch) => {

    
    try {
        const res = await axios.post(`${Prod01}/admin/signup`, values);

        if(res){
            dispatch({
                type: SHOW_ALERT_MESSAGE,
                payload: "New Admin Added"
              });
            dispatch({
                type: HIDE_ALERT_MESSAGE
            })
        }
    }
     catch (error) {
        dispatch({
        type: FETCH_ERROR,
        payload: 'Email already exists'
      })
      dispatch({
        type: HIDE_ALERT_MESSAGE
      })
    }
}

export const resetpasswordById = (password, id) => async(dispatch) => {  

    try {
       const res = await axios.post(`${Prod01}/general/resetpasswordanyuser`, {
           id: id,
           password: password
       });
      
       if(res){
        dispatch({
            type: SHOW_ALERT_MESSAGE,
            payload: "Password has been reset"
          });
       }
       
       
    } catch (error) {
       dispatch({
        type: FETCH_ERROR,
        payload: error?.response?.data?.message || error.message
      })

    }
}



// Clear errors
export const clearErrors = () => async(dispatch) => {
    dispatch({
        type: CLEAR_ERRORS,
    })
}